<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kode Akun</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="kodeAkunList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          name="account code"
          label="name"
          v-model="formData.kode_id"
          placeholder="Pilih Kode Akun"
        />
        <span class="text-danger text-sm">{{ errors.first("account code") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Jenis Transaksi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="jenisTransaksiList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          name="transaction list"
          label="name"
          v-model="formData.jenis_id"
          placeholder="Pilih Kode Akun"
        />
        <span class="text-danger text-sm">{{ errors.first("transaction list") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Status</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="status"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          name="status"
          label="text"
          v-model="formData.status"
          placeholder="Pilih Kode Akun"
        />
        <span class="text-danger text-sm">{{ errors.first("status") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kode Aplikator</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="applicator code"
          class="w-full sidebar-input"
          v-model="formData.kode_aplikator"
          placeholder="Isi Dengan Kode Aplikator"
        />
        <span class="text-danger text-sm">{{ errors.first("applicator code") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Nama Journal"
        />
        <span class="text-danger text-sm">{{ errors.first("name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Uraian</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-textarea
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="description"
          class="w-full sidebar-input"
          v-model="formData.uraian"
          placeholder="Isi Dengan Uraian"
        />
        <span class="text-danger text-sm">{{ errors.first("description") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      status: [
        { id: 1, text: "Aktif" },
        { id: 2, text: "Tidak Aktif" },
      ],
      formData: {
        kode_id: null,
        jenis_id: null,
        status: null,
        kode_aplikator: null,
        name: "",
        uraian: "",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Master Journal" : "Tambah Master Journal";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    kodeAkunList() {
      return this.$store.state.journal.kodeAkunList;
    },
    jenisTransaksiList() {
      return this.$store.state.transaksi.jenisList;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.kode_id !== null &&
        this.formData.jenis_id !== null &&
        this.formData.kode_aplikator !== null &&
        this.formData.status !== null &&
        this.formData.name !== "" &&
        this.formData.uraian !== ""
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.kode_id = this.passData.journal ? this.passData.journal.id : null;
        this.formData.jenis_id = this.passData.jenis ? this.passData.jenis.id : null;
        this.formData.kode_aplikator = this.passData.kode_aplikator;
        this.formData.status = parseInt(this.passData.status);
        this.formData.name = this.passData.name;
        this.formData.uraian = this.passData.uraian;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.kode_id = null;
      this.formData.jenis_id = null;
      this.formData.kode_aplikator = null;
      this.formData.status = null;
      this.formData.name = "";
      this.formData.uraian = "";
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      this.$store
        .dispatch("journal/cudMaster", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Master Journal Sukses!"
                : "Tambah Master Journal Sukses!",
            text:
              this.passData !== null
                ? `Master Journal ${v.name} Berhasil diedit`
                : `Master Journal ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>
